export default __webpack_public_path__ + "static/media/elbow-duct-making.79eec5db.jpg";